import {
  Box,
  CardContent,
  CardHeader,
  Grid,
  LinearProgress,
  Stack,
  Typography
} from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom'

import Icon from 'components/Icon'
import { DONUT_RELIABILITY_COLOR_MAP } from 'components/services/service-utils'
import theme from 'theme'

export const HowReliabilityIsMeasured: React.FC = () => {
  return (
    <>
      <CardHeader
        title={
          <Typography variant="h6">
            How will Reliability be measured?{' '}
            <Link
              target="_blank"
              to={{
                pathname:
                  'https://www.gremlin.com/blog/how-gremlins-reliability-score-works/'
              }}
            >
              <Icon
                css={{ fontSize: theme.fontSizes[2] }}
                icon="arrowUpRightFromSquare"
              />
            </Link>
          </Typography>
        }
      />
      <CardContent>
        <Typography variant="body2">
          Reliability Scores are out of 100 points. There are three categories
          that contribute to a Service's reliability.
        </Typography>

        <Grid container justifyContent="center" mt={2}>
          <Grid item justifyContent="center" xs={7}>
            <Stack direction="row" justifyContent="right" spacing={1}>
              <Typography noWrap css={{ textOverflow: 'clip' }} variant="body2">
                Redundancy
              </Typography>
              <Typography
                css={{ color: theme.colors.steel[0] }}
                variant="body2"
              >
                +15
              </Typography>
            </Stack>
            <Box
              sx={{
                width: '100%',
                '& .MuiLinearProgress-barColorPrimary': {
                  backgroundColor: DONUT_RELIABILITY_COLOR_MAP['REDUNDANCY']
                }
              }}
            >
              <LinearProgress
                sx={{
                  backgroundColor: '#d9d9d9'
                }}
                title="Redundancy"
                value={60}
                variant="determinate"
              />
            </Box>
          </Grid>
          <Grid item justifyContent="center" xs={7}>
            <Stack direction="row" justifyContent="right" spacing={1}>
              <Typography noWrap css={{ textOverflow: 'clip' }} variant="body2">
                Scalability
              </Typography>
              <Typography
                css={{ color: theme.colors.steel[0] }}
                variant="body2"
              >
                +24
              </Typography>
            </Stack>
            <Box
              sx={{
                width: '100%',
                '& .MuiLinearProgress-barColorPrimary': {
                  backgroundColor: DONUT_RELIABILITY_COLOR_MAP['SCALABILITY']
                }
              }}
            >
              <LinearProgress
                sx={{
                  backgroundColor: '#d9d9d9'
                }}
                title="Redundancy"
                value={92}
                variant="determinate"
              />
            </Box>
          </Grid>
          <Grid item justifyContent="center" xs={7}>
            <Stack direction="row" justifyContent="right" spacing={1}>
              <Typography noWrap css={{ textOverflow: 'clip' }} variant="body2">
                Dependencies
              </Typography>
              <Typography
                css={{ color: theme.colors.steel[0] }}
                variant="body2"
              >
                +11
              </Typography>
            </Stack>
            <Box
              sx={{
                width: '100%',
                '& .MuiLinearProgress-barColorPrimary': {
                  backgroundColor: DONUT_RELIABILITY_COLOR_MAP['DEPENDENCIES']
                }
              }}
            >
              <LinearProgress
                sx={{
                  backgroundColor: '#d9d9d9'
                }}
                value={15}
                variant="determinate"
              />
            </Box>
          </Grid>
        </Grid>
      </CardContent>
    </>
  )
}
